import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private messageSource = new BehaviorSubject({});

  public currentMessage = this.messageSource.asObservable();

  clear() {
    this.messageSource.complete();
    this.messageSource = new BehaviorSubject({});

    this.currentMessage = this.messageSource.asObservable();
  }
}
